import type { CardHooks } from "./registry";
import { makeBuff } from "../playtestEngine";

/**
 * Fluid Motion — Maneuver utility.
 * Effect: for the rest of the round, your weapon attacks/defends cost 1
 * less stamina.
 *
 * Implementation:
 *   • Queue a buff with kind `weapon-cost-reduction` and trigger `round-end`
 *     so it never fires (firePendingBuffs ignores `round-end`-trigger
 *     buffs) and persists in pendingBuffs until pruneBuffs drops it at the
 *     next round start. Mirrors Ignite Blade's quick-power-bonus pattern.
 *   • `stanceCostReduction()` in playtestEngine.ts reads this buff and
 *     applies the amount whenever the source card is an Equipment weapon.
 *
 * Amount lives on the buff (data-driven) so future cards can drop weapon
 * cost by different amounts without touching the engine.
 */
export const fluidMotion: CardHooks = {
  onUtilityPlay: (ctx) => ({
    queueSelfBuff: makeBuff(
      "Fluid Motion",
      "round-end",
      { kind: "weapon-cost-reduction", amount: 1 },
      ctx.game.round,
    ),
    log: ["Fluid Motion — weapon actions cost 1 less this round"],
  }),
};
